export default class Breakpoint {}

Breakpoint.Small = 640;
Breakpoint.Medium = 768;
Breakpoint.Large = 1024;
Breakpoint.ExtraLarge = 1280;
Breakpoint.DoubleExtraLarge = 1536;
